// src/AppRoutes.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import MissionPage from "./pages/MissionPage";
import ActivitiesPage from "./pages/ActivitiesPage";
import ProjectsPage from "./pages/ProjectsPage";
import VibhagPage from "./pages/VibhagPage";
import WisdomPage from "./pages/WisdomPage";
import ContactPage from "./pages/ContactPage";
import SadguruHospitalPage from "./pages/SadguruMoredadaHospital";
import Matrukund from "./pages/Matrukund";
import AnnaChaatra from "./pages/AnnaChatra";
import Donation from "./pages/Donation";
import ScrollToTop from "./components/ScrollToTop";
import DattDham from "./pages/DattaDham";
import ShreeGurupeeth from "./pages/ShreeGurupeeth";
import KrushiMahostavEvent from "./events/KrushiMahostavEvent";
import PrivacyPolicyDindori from "./pages/privacyPolicyDindori";
import Activities from "./events/Activities";
import CountdownPage from "./pages/CountdownPage";
import RecentActivities from "./pages/RecentActivities";
import LoginPage from "./pages/LoginPage";

// // ===== CEREMONY CONFIGURATION =====
// const CEREMONY_DATE = new Date('2025-10-23T00:00:00').getTime();

// const RootRoute = () => {
//   const now = new Date().getTime();
  
//   // If ceremony date has passed, always show HomePage
//   if (now >= CEREMONY_DATE) {
//     return <HomePage />;
//   }
  
//   // Before ceremony date, check if ceremony is completed
//   const ceremonyCompleted = localStorage.getItem('ceremonySeen');
  
//   if (ceremonyCompleted === 'true') {
//     return <HomePage />;
//   }
  
//   // Show countdown for ceremony
//   return <CountdownPage />;
// };
// ===== END CEREMONY CONFIGURATION =====

const AppRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Root route - Smart ceremony logic */}
        <Route path="/" element={ <HomePage />} />
        
        {/* Activity Details */}
        <Route path="/recent-activities/:activityId" element={<RecentActivities />} />
        
        {/* Main Pages */}
        <Route path="/about" element={<AboutPage />} />
        <Route path="/mission" element={<MissionPage />} />
        <Route path="/activities" element={<ActivitiesPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/vibhag" element={<VibhagPage />} />
        <Route path="/wisdom" element={<WisdomPage />} />
        <Route path="/contact" element={<ContactPage />} />
        
        <Route path="/login" element={<LoginPage />} />
        {/* Project Pages */}
        <Route path="/sadguru-hospital" element={<SadguruHospitalPage />} />
        <Route path="/Matrukund" element={<Matrukund />} />
        <Route path="/annachatra" element={<AnnaChaatra />} />
        <Route path="/datt-dham" element={<DattDham />} />
        <Route path="/shree-gurupeeth" element={<ShreeGurupeeth />} />
        
        {/* Events */}
        <Route path="/events/krushi-mahostav" element={<KrushiMahostavEvent />} />
        <Route path="/allActivities" element={<Activities />} />
        
        {/* Other */}
        <Route path="/donation" element={<Donation />} />
        <Route path="/privacy-policy-dindori" element={<PrivacyPolicyDindori />} />
        
        {/* Catch all - redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

export default AppRoutes;